import React from "react";
import LayersIcon from '@mui/icons-material/Layers';
import ScienceIcon from '@mui/icons-material/Science';
import SettingsIcon from '@mui/icons-material/Settings';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';

const ElaboracionSection = ({
  elaboracionRecords,
  granelRecords,
  isFormOpen,
  setIsFormOpen,
  formData,
  setFormData,
  handleSaveElaboracion
}) => {
  const [selectedRecord, setSelectedRecord] = React.useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEditRecord = (rec) => {
    if (rec.status !== "borrador") {
      alert("Solo se pueden editar registros que se encuentren en estado BORRADOR.");
      return;
    }
    setFormData({
      fechaIngreso: rec.fechaIngreso || "",
      loteOrigen: rec.loteOrigen || "",
      volumenOrigen: rec.volumenOrigen ? String(rec.volumenOrigen).replace(/[^\d.]/g, '') : "",
      pctAlcOrigen: rec.pctAlcOrigen ? String(rec.pctAlcOrigen).replace(/[^\d.]/g, '') : "",
      categoriaOrigen: rec.categoriaOrigen || "Mezcal",
      claseOrigen: rec.claseOrigen || "",
      ingredientesOrigen: rec.ingredientesOrigen || "",
      edadOrigen: rec.edadOrigen || "",
      analisisOrigen: rec.analisisOrigen || "",
      tipoMagueyOrigen: rec.tipoMagueyOrigen || "",
      ingredientesAdicionados: rec.ingredientesAdicionados || "",
      procesoRealizado: rec.procesoRealizado || "ABOCADO CON",
      descripcionProceso: rec.descripcionProceso || "",
      fechaSalida: rec.fechaSalida || "",
      loteSalida: rec.loteSalida || "",
      volumenSalida: rec.volumenSalida ? String(rec.volumenSalida).replace(/[^\d.]/g, '') : "",
      pctAlcSalida: rec.pctAlcSalida ? String(rec.pctAlcSalida).replace(/[^\d.]/g, '') : "",
      claseSalida: rec.claseSalida || "",
      observaciones: rec.observaciones || ""
    });
    setIsFormOpen(true);
  };

  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header">
          <h2>Elaboración de Clases, Reprocesos y Reacondicionamientos (Sección VI)</h2>
          <button 
            onClick={() => setIsFormOpen(true)}
            className="btn-add-new"
          >
            <AddIcon style={{ fontSize: 18 }} />
            <span>Nuevo Registro Sección VI</span>
          </button>
        </div>

        <div className="records-list-wrapper">
          <table className="records-table">
            <thead>
              <tr>
                <th colSpan="10" style={{ textAlign: "center", background: "rgba(107, 142, 35, 0.2)", color: "var(--agave-green)" }}>Características del Mezcal Antes del Proceso</th>
                <th colSpan="3" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Procesamiento del Mezcal</th>
                <th colSpan="5" style={{ textAlign: "center", background: "rgba(107, 142, 35, 0.2)", color: "var(--agave-green)" }}>Resultado del Proceso</th>
                <th colSpan="4" style={{ textAlign: "center" }}>Finalización</th>
              </tr>
              <tr>
                {/* Antes del proceso */}
                <th>Fecha Ingreso</th>
                <th>Lote Origen</th>
                <th>Volumen (L)</th>
                <th>% Alc. Vol.</th>
                <th>Categoría</th>
                <th>Clase</th>
                <th>Ingredientes</th>
                <th>Edad</th>
                <th>Nº Análisis</th>
                <th>Tipo Maguey</th>
                
                {/* Procesamiento */}
                <th>Ingredientes Adicionados</th>
                <th>Proceso</th>
                <th>Descripción del Proceso</th>
                
                {/* Resultado */}
                <th>Fecha Salida</th>
                <th>Lote Final</th>
                <th>Volumen Final (L)</th>
                <th>% Alc. Vol.</th>
                <th>Clase Final</th>
                
                {/* Final */}
                <th>Observaciones</th>
                <th>V.Bo. Inspector</th>
                <th>Estado</th>
                <th style={{ textAlign: "center" }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {elaboracionRecords.map((rec, i) => (
                <tr key={i}>
                  <td>{rec.fechaIngreso}</td>
                  <td style={{ fontWeight: 800 }}>{rec.loteOrigen}</td>
                  <td>{rec.volumenOrigen} L</td>
                  <td>{rec.pctAlcOrigen}%</td>
                  <td>{rec.categoriaOrigen}</td>
                  <td>{rec.claseOrigen}</td>
                  <td>{rec.ingredientesOrigen}</td>
                  <td>{rec.edadOrigen}</td>
                  <td>{rec.analisisOrigen}</td>
                  <td>{rec.tipoMagueyOrigen}</td>
                  
                  <td>{rec.ingredientesAdicionados}</td>
                  <td>
                    <span className="badge-status" style={{ background: "rgba(210, 105, 30, 0.15)", color: "var(--copper)" }}>
                      {rec.procesoRealizado}
                    </span>
                  </td>
                  <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {rec.descripcionProceso}
                  </td>
                  
                  <td>{rec.fechaSalida}</td>
                  <td style={{ fontWeight: 800, color: "var(--agave-green)" }}>{rec.loteSalida}</td>
                  <td><strong>{rec.volumenSalida} L</strong></td>
                  <td>{rec.pctAlcSalida}%</td>
                  <td>{rec.claseSalida}</td>
                  
                  <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {rec.observaciones}
                  </td>
                  <td style={{ fontSize: "11px" }}>{rec.inspector}</td>
                  <td>
                    <span className={`badge-status ${rec.status}`}>
                      {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                    </span>
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <div style={{ display: "flex", justifyContent: "center", gap: "6px" }}>
                      <button 
                        type="button" 
                        onClick={() => setSelectedRecord(rec)}
                        title="Ver Detalle Completo"
                        style={{ background: "rgba(52, 152, 219, 0.15)", color: "#3498db", border: "1px solid rgba(52, 152, 219, 0.3)", borderRadius: "6px", padding: "5px 8px", cursor: "pointer", display: "flex", alignItems: "center" }}
                      >
                        <VisibilityIcon style={{ fontSize: 16 }} />
                      </button>

                      <button 
                        type="button" 
                        onClick={() => handleEditRecord(rec)}
                        disabled={rec.status !== "borrador"}
                        title={rec.status === "borrador" ? "Editar Registro" : "Solo editables en estado Borrador"}
                        style={{ 
                          background: rec.status === "borrador" ? "rgba(241, 196, 15, 0.15)" : "rgba(255,255,255,0.04)", 
                          color: rec.status === "borrador" ? "#f1c40f" : "var(--text-muted)", 
                          border: rec.status === "borrador" ? "1px solid rgba(241, 196, 15, 0.3)" : "1px solid rgba(255,255,255,0.08)", 
                          borderRadius: "6px", 
                          padding: "5px 8px", 
                          cursor: rec.status === "borrador" ? "pointer" : "not-allowed", 
                          display: "flex", 
                          alignItems: "center",
                          opacity: rec.status === "borrador" ? 1 : 0.4
                        }}
                      >
                        <EditIcon style={{ fontSize: 16 }} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* MODAL DE DETALLE COMPLETO DE ELABORACION */}
        {selectedRecord && (
          <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 999, padding: "20px" }}>
            <div className="detail-card animate-fadeIn" style={{ maxWidth: "700px", width: "100%", maxHeight: "90vh", overflowY: "auto", background: "#161b22", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "12px", padding: "24px", position: "relative" }}>
              <button 
                onClick={() => setSelectedRecord(null)}
                style={{ position: "absolute", top: "16px", right: "16px", background: "transparent", border: "none", color: "var(--text-muted)", cursor: "pointer" }}
              >
                <CloseIcon />
              </button>

              <div style={{ borderBottom: "1px solid rgba(255,255,255,0.1)", paddingBottom: "12px", marginBottom: "16px" }}>
                <span className={`badge-status ${selectedRecord.status}`} style={{ float: "right", marginTop: "4px" }}>
                  {selectedRecord.status === "aprobado" ? "Aprobado" : selectedRecord.status === "revision" ? "En revisión" : "Borrador"}
                </span>
                <h3 style={{ margin: 0, color: "var(--agave-green)", fontSize: "20px" }}>Lote Origen: {selectedRecord.loteOrigen} → Final: {selectedRecord.loteSalida}</h3>
                <small style={{ color: "var(--text-muted)" }}>Detalle de Elaboración de Clases, Reprocesos (Sección VI)</small>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", fontSize: "14px" }}>
                <div><strong>Fecha Ingreso:</strong> {selectedRecord.fechaIngreso}</div>
                <div><strong>Volumen Origen:</strong> {selectedRecord.volumenOrigen} L ({selectedRecord.pctAlcOrigen}%)</div>
                <div><strong>Categoría Origen:</strong> {selectedRecord.categoriaOrigen}</div>
                <div><strong>Clase Origen:</strong> {selectedRecord.claseOrigen}</div>
                <div><strong>Ingredientes Origen:</strong> {selectedRecord.ingredientesOrigen || "N/A"}</div>
                <div><strong>Análisis:</strong> {selectedRecord.analisisOrigen}</div>
                <div><strong>Proceso Realizado:</strong> <span style={{ color: "var(--copper)", fontWeight: 700 }}>{selectedRecord.procesoRealizado}</span></div>
                <div><strong>Aditivos:</strong> {selectedRecord.ingredientesAdicionados || "Ninguno"}</div>
                <div><strong>Fecha Salida:</strong> {selectedRecord.fechaSalida}</div>
                <div><strong>Lote Final:</strong> {selectedRecord.loteSalida}</div>
                <div><strong>Volumen Final:</strong> <span style={{ color: "var(--agave-green)", fontWeight: 700 }}>{selectedRecord.volumenSalida} L ({selectedRecord.pctAlcSalida}%)</span></div>
                <div><strong>Clase Final:</strong> {selectedRecord.claseSalida}</div>
                <div><strong>Inspector:</strong> {selectedRecord.inspector}</div>
              </div>

              <div style={{ marginTop: "16px", paddingTop: "12px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                <strong>Descripción del Proceso:</strong>
                <p style={{ margin: "6px 0", color: "var(--text-muted)", fontSize: "13px" }}>{selectedRecord.descripcionProceso || "Sin descripción."}</p>
                <strong>Observaciones:</strong>
                <p style={{ margin: "6px 0 0 0", color: "var(--text-muted)", fontSize: "13px" }}>{selectedRecord.observaciones || "Sin observaciones."}</p>
              </div>

              <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                {selectedRecord.status === "borrador" && (
                  <button 
                    onClick={() => {
                      const rec = selectedRecord;
                      setSelectedRecord(null);
                      handleEditRecord(rec);
                    }}
                    className="btn-add-new"
                    style={{ padding: "8px 16px", fontSize: "13px" }}
                  >
                    <EditIcon style={{ fontSize: 16 }} />
                    <span>Editar Registro</span>
                  </button>
                )}
                <button onClick={() => setSelectedRecord(null)} className="btn-secondary-custom" style={{ padding: "8px 16px" }}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2>Nueva Elaboración de Clases / Reprocesos (Sección VI)</h2>
      </div>

      <div className="cards-container-grid">
        {/* CARACTERISTICAS DEL MEZCAL ANTES DEL PROCESO */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <LayersIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Antes del Proceso</h2>
              <p>Características del mezcal a transformar</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="date" 
                id="elabFechaIngreso" 
                value={elabFechaIngreso} 
                onChange={e => setElabFechaIngreso(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabFechaIngreso">Fecha de Ingreso</label>
            </div>

            <div className="custom-input-group">
              <select 
                value={elabLoteOrigen} 
                onChange={e => setElabLoteOrigen(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="">-- Seleccionar Lote Granel --</option>
                {granelRecords.map((r, idx) => (
                  <option key={idx} value={r.noLote}>
                    {r.noLote} (Contenedor: {r.idContenedor} - {r.invFinalVol})
                  </option>
                ))}
              </select>
              <label className="custom-input-label">Lote Origen (Validado Granel)</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                id="elabVolumenOrigen" 
                value={elabVolumenOrigen} 
                onChange={e => setElabVolumenOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabVolumenOrigen">Volumen (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                id="elabPctAlcOrigen" 
                value={elabPctAlcOrigen} 
                onChange={e => setElabPctAlcOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabPctAlcOrigen">% Alc. Vol.</label>
              <span className="input-suffix">%</span>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <select 
                value={elabCategoriaOrigen} 
                onChange={e => setElabCategoriaOrigen(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="Mezcal">Mezcal</option>
                <option value="Mezcal Artesanal">Mezcal Artesanal</option>
                <option value="Mezcal Ancestral">Mezcal Ancestral</option>
              </select>
              <label className="custom-input-label">Categoría Origen</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                id="elabClaseOrigen" 
                value={elabClaseOrigen} 
                onChange={e => setElabClaseOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabClaseOrigen">Clase Origen</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                id="elabIngredientesOrigen" 
                value={elabIngredientesOrigen} 
                onChange={e => setElabIngredientesOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabIngredientesOrigen">Ingredientes Origen</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                id="elabEdadOrigen" 
                value={elabEdadOrigen} 
                onChange={e => setElabEdadOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabEdadOrigen">Edad Origen</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                id="elabAnalisisOrigen" 
                value={elabAnalisisOrigen} 
                onChange={e => setElabAnalisisOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabAnalisisOrigen">Análisis Fisicoquímico</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                id="elabTipoMagueyOrigen" 
                value={elabTipoMagueyOrigen} 
                onChange={e => setElabTipoMagueyOrigen(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabTipoMagueyOrigen">Tipo de Maguey</label>
            </div>
          </div>
        </section>

        {/* PROCESAMIENTO DEL MEZCAL */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <WaterDropIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Procesamiento</h2>
              <p>Modificaciones, aditivos y tipo de proceso</p>
            </div>
          </header>

          <div className="custom-input-group">
            <input 
              type="text" 
              id="elabIngredientesAdicionados" 
              value={elabIngredientesAdicionados} 
              onChange={e => setElabIngredientesAdicionados(e.target.value)} 
              className="custom-input-field"
              placeholder="Ej: Pechuga de pavo, frutas, hierbas..."
            />
            <label className="custom-input-label" htmlFor="elabIngredientesAdicionados">Ingredientes Adicionados (Orden Cuantitativo)</label>
          </div>

          <div className="custom-input-group">
            <select 
              value={elabProcesoRealizado} 
              onChange={e => setElabProcesoRealizado(e.target.value)}
              className="custom-select-field"
              style={{ padding: "18px 16px 8px 16px" }}
            >
              <option value="ABOCADO CON">ABOCADO CON</option>
              <option value="DESTILADO CON">DESTILADO CON</option>
              <option value="REPROCESO Y/O REACONDICIONAMIENTO">REPROCESO Y/O REACONDICIONAMIENTO</option>
            </select>
            <label className="custom-input-label">Proceso Realizado (Marque con "X")</label>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea 
              id="elabDescripcionProceso" 
              value={elabDescripcionProceso} 
              onChange={e => setElabDescripcionProceso(e.target.value)} 
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
              placeholder="Breve descripción del proceso o reacondicionamiento..."
            />
            <label className="custom-input-label" htmlFor="elabDescripcionProceso">Descripción Breve del Proceso</label>
          </div>
        </section>

        {/* RESULTADO DEL PROCESO */}
        <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <ScienceIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Resultado del Proceso</h2>
              <p>Características del lote final obtenido</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="date" 
                id="elabFechaSalida" 
                value={elabFechaSalida} 
                onChange={e => setElabFechaSalida(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabFechaSalida">Fecha de Salida</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                id="elabLoteSalida" 
                value={elabLoteSalida} 
                onChange={e => setElabLoteSalida(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabLoteSalida">Lote Final Obtenido</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                id="elabVolumenSalida" 
                value={elabVolumenSalida} 
                onChange={e => setElabVolumenSalida(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabVolumenSalida">Volumen Final (L)</label>
              <span className="input-suffix">L</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                step="0.1"
                id="elabPctAlcSalida" 
                value={elabPctAlcSalida} 
                onChange={e => setElabPctAlcSalida(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabPctAlcSalida">% Alc. Vol. Final</label>
              <span className="input-suffix">%</span>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                id="elabClaseSalida" 
                value={elabClaseSalida} 
                onChange={e => setElabClaseSalida(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label" htmlFor="elabClaseSalida">Clase Final Obtenida</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea 
              id="elabObservaciones" 
              value={elabObservaciones} 
              onChange={e => setElabObservaciones(e.target.value)} 
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
              placeholder="Notas generales..."
            />
            <label className="custom-input-label" htmlFor="elabObservaciones">Observaciones</label>
          </div>
        </section>
      </div>

      <div className="button-row">
        <button type="button" className="btn-secondary-custom" onClick={() => setIsFormOpen(false)}>Volver</button>
        <button 
          type="button" 
          className="btn-primary-custom" 
          onClick={() => handleSaveElaboracion("revision")}
        >
          <CheckCircleIcon style={{ fontSize: 16 }} />
          <span>Registrar Sección VI</span>
        </button>
      </div>
    </div>
  );
};

export default ElaboracionSection;
